import {
  INPUT_CHANGE,
  INPUT_ERROR,
  LOGIN_ERROR, LOGIN_REQUEST,
  LOGIN_SUCCESS, LOGOUT_SUCCESS
} from "./login-action-types";

const initialState = {
  username: {
    value: "",
    error: "",
    name: "Username",
    type: "text",
    field: "username"
  },
  password: {
    value: "",
    error: "",
    name: "Password",
    type: "password",
    field: "password"
  },
  token: "",
  error: "",
  loading: false
};

export default (state = initialState, action) => {
  const { field, value, error, token } = action;
  switch (action.type) {

    case LOGOUT_SUCCESS:
      return {
        ...state,
        token: ""
      };

    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: ""
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        token,
        loading: false,
        error: "",
        username: {
          ...state.username,
          value: ""
        },
        password: {
          ...state.password,
          value: ""
        }
      };

    case LOGIN_ERROR:
      return {
        ...state,
        error,
        loading: false
      };

    case INPUT_CHANGE:
      return {
        ...state,
        [field]: {
          ...state[field],
          value,
          error: ""
        }
      };

    case INPUT_ERROR:
      return {
        ...state,
        [field]: {
          ...state[field],
          error
        },
        loading: false
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/login/login-reducer.js